import anime from 'animejs';
import $ from 'jquery';
import lottie from 'lottie-web';
import 'slick-carousel';

import Prep from './animations/prep/prep.js';
import json from './animations/transition/bg-transition.json';

var anim = {};

for (var i = 1; i < 5; i++) {
  var path  = 'src/images/animations/bg-transitions/'+i+'/';
  var options = {
    container: $('.bg-anim.s'+i)[0],
    renderer: 'svg',
    loop: false,
    autoplay: false,
    animationData: json,
    assetsPath: path,
  };
  anim['s'+i] = lottie.loadAnimation(options);

}


const slide = (direction)  => {
  isSliding = true;
  $('.carousel-controls').animate({opacity: 0},0);

  let animacion = sections[currentSlide];
  animacion.outAnimation(direction);

  currentSlide = (direction == 'left') ?
                  Math.max(currentSlide - 1, 0) :
                  Math.min(currentSlide + 1, 4);


  //setting active menu item
  $('.menu li').removeClass('active');
  $('.menu li').eq(currentSlide).addClass('active');

  $('.carousel-dots .current-slide').html(currentSlide+1);

  $('.carousel-dots li').removeClass('liactive');
  $('.carousel-dots li').eq(currentSlide).addClass('liactive');

  var i = (direction === 'left') ? currentSlide+1 : currentSlide;
  var d = (direction === 'left') ? -1 : 1;

  //play animation backwards
  anim['s'+i].setDirection(d);
  anim['s'+i].play();

  //move the current animation to the very top.
  $('.bg-anim').css({'z-index':''});
  $('.s'+i).css({'z-index':9999});

  //move the current animation to the very top.
  $('.slide').attr('class', 'slide');
  $('.slide').eq(currentSlide).addClass("current");

  //play background animation
  animacion = sections[currentSlide];
  animacion.inAnimation(direction);

  setTimeout(function () {
    isSliding = false;
  }, 1500);

  switch (currentSlide) {
    case 0:
      $('.carousel-controls').delay(500).animate({opacity: 1},500);
      $('.left').css({'border-color': '#B7F4E4'});
      $('.right').css({'border-color': '#BED5EB'});
      break;
    case 1:
      $('.carousel-controls').delay(500).animate({opacity: 1},500);
      $('.left').css({'border-color': '#B7F4E4'});
      $('.right').css({'border-color': '#F5E2B0'});
      break;
    case 2:
      $('.carousel-controls').delay(500).animate({opacity: 1},500);
      $('.left').css({'border-color': '#BED5EB'});
      $('.right').css({'border-color': '#C7BEEB'});
      break;
    case 3:
      $('.carousel-controls').delay(500).animate({opacity: 1},500);
      $('.left').css({'border-color': '#F2E5C2'});
      $('.right').css({'border-color': '#F6C3B6'});
      break;
    case 4:
      $('.carousel-controls').delay(500).animate({opacity: 1},500);
      $('.left').css({'border-color': '#C7BEEB'});
      $('.right').css({'border-color': '#F6C3B6'});
      break;
    default:
  }

};

const openMenu = () => {
  if ($('.menu').is(":visible")) {
    $('.menu').animate({opacity:0}, 500, () => {
      $('.menu').css({display: 'none'});
    });
    if ($(window).width() <= 550) {
      $('.brand').animate({opacity:1}, 500);
      $('.urban-logo').hide();
      $('.urban-logo').css({ right: '', transform: ''});
      $('.cotton-logo').removeClass('mobile-menu');
    }
    window.history.pushState('wardrober', 'wardrober', '/');
  } else {
    $('.menu').css({display: 'block'});
    $('.menu').animate({opacity:1}, 500);
    if ($(window).width() <= 550) {
      $('.brand').animate({opacity:0}, 500);
      $('.urban-logo').css({ right: '50%', transform: 'translateX(50%)'});
      $('.urban-logo').show();
      setTimeout(function () {
        $('.cotton-logo').addClass('mobile-menu');
      }, 500);
    }
    window.history.pushState('menu', 'Menu', '/menu');
  }
};

const closeModal = () => {
  $('.modal').animate({'opacity':''}, 500);
  $('.urban-star').removeClass('open');

  if ($(window).width() <= 768) {
    $('.brand').show();
  }

  setTimeout(function () {
    $('.modal').animate({'z-index': ''}, 500);
    $(".first-row, .second-row, .third-row").slick("unslick");
    $(".first-row, .second-row, .third-row").empty();
  }, 500);
};


const goToSlide = (s, toggleMenu) => {
  var direction = (s < currentSlide)? 'left' : 'right';
  var cant = Math.abs((s-currentSlide));

  $('.carousel').animate({opacity:0}, 0);
  $('.modal').css({'z-index': ''});
  $('.modal').css({'opacity':''});

  $('.urban-star').removeClass('open');

  for (var i = 0; i < cant; i++) {
    setTimeout(function () {
      slide(direction);
    }, i*100);
  }
  if (toggleMenu) {
    openMenu();
  }


  setTimeout(function () {
    if ($(window).width() <= 768) {
      $('.brand').show();
    }
    $('.carousel').animate({opacity:1}, 500);
  }, 1000);
};


var categories = {
  's': 'Sneakerhead',
  'aa': 'All American',
  'p': 'Prep',
  'a': 'Active',
  't': 'Trendsetter'
};

const gotolink = (e,url) => {
  if (e.target.classList.contains('hotspot')) {
    if (e.currentTarget.childNodes[3].classList.contains('open')) {
      e.currentTarget.childNodes[3].classList.remove("open");
    } else {
      e.currentTarget.childNodes[3].classList.add("open");
    }
  }
  else {
    var item = $(e.currentTarget).find('.title').text();
    var brand = $(e.currentTarget).find('.item-brand').text();
    var cat = $('.modal').attr("class").split(' ');
    cat = cat.filter(function(item) {
      return item !== 'modal';
    })[0];
    //ugly hack to know if is centered slide.
    if (e.currentTarget.parentElement.parentElement.classList.contains('slick-center')){
      var win = window.open(url, '_blank');
      win.focus();
      window.dataLayer.push({ event: 'item_clicked', name: item, brand: brand, category: categories[cat]});
    }
  }
};


const showRecomendation = () => {

  var reco = [];
  var reco_text = "";
  if ($('.modal').hasClass('s')) {
    reco = [3,8,6];
    reco_text = "When Jonah Hill invites you to brunch in NoHo, you show up like this…";
  }
  if ($('.modal').hasClass('aa')) {
    reco = [8,6,6];
    reco_text = "This is the official outfit of cracking stone crab claws like a gentleman.";
  }
  if ($('.modal').hasClass('p')) {
    reco = [1,0,4];
    reco_text = "You’ve just nailed the casual Martha’s Vineyard barbecue.";
  }
  if ($('.modal').hasClass('a')) {
    reco = [4,0,2];
    reco_text = "This outfit just swept the floor with everyone in 3-on-3.";
  }
  if ($('.modal').hasClass('t')) {
    reco = [4,3,5];
    reco_text = "Put this on. Loiter around fashion week. Enjoy being photographed.";
  }

  $('.first-row').slick('slickGoTo',reco[0]);
  $('.second-row').slick('slickGoTo', reco[1]);
  $('.third-row').slick('slickGoTo', reco[2]);

  $('.urban-star').addClass('open');
  $('.urban-star').find('.recomendation > span').text(reco_text);
};

const equals = (a1, a2) => {
  return a1.length === a2.length && a1.every((v,i) => v === a2[i]);
};

export { slide, openMenu, goToSlide, closeModal, gotolink, showRecomendation};
